import React, { Component } from 'react';

class Pattern extends Component {
    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    handleScroll(event) {
        let pattern = document.getElementById("pattern");
        // window.pageYOffset works for Firefox, Safari and Chrome
        // document.documentElement.scrollTop only Firefox
        // document.body.scrollTop only Safari and Chrome
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0,
            windowH = window.innerHeight,
            footerH = document.getElementById("footer") !== null ? document.getElementById("footer").clientHeight : 0,
            scrollBottom = scrollTop + windowH,
            pageH = document.getElementById("App").clientHeight;
        if (scrollBottom > (pageH - footerH)) {
            pattern.style.position = "absolute";
            pattern.style.bottom = footerH + "px";
        } else {
            pattern.style.position = "fixed";
            pattern.style.bottom = "0px";
        }
    }
    render() {
        const info = location.pathname.split("/")[1] === "info" ? -1 : 1000;
        const style = {
            zIndex: info,
            opacity: info
        }
        return (
            <div id="pattern" style={style}/>
        );
    }
}

export default Pattern;



// WEBPACK FOOTER //
// ./src/components/All/Pattern.js